// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3fb29873","239":"5beb19ea","453":"8b1f7f24","732":"aa373000"}[chunkId] + ".chunk.js";
};